import BasicTopicList from "discourse/components/basic-topic-list";
import PluginOutlet from "discourse/components/plugin-outlet";
import lazyHash from "discourse/helpers/lazy-hash";
import DConditionalLoadingSpinner from "discourse/ui-kit/d-conditional-loading-spinner";
import DEmptyState from "discourse/ui-kit/d-empty-state";
import DLoadMore from "discourse/ui-kit/d-load-more";
import dConcatClass from "discourse/ui-kit/helpers/d-concat-class";
import { i18n } from "discourse-i18n";

export default <template>
  <section class="community-topic-aggregation">
    {{#if @model.game}}
      <section class="community-topic-aggregation__featured">
        <PluginOutlet
          @name="community-game-banner"
          @outletArgs={{lazyHash model=@model}}
        />
        <PluginOutlet
          @name="community-game-pinned-topics"
          @outletArgs={{lazyHash model=@model}}
        />
      </section>
      <header
        class={{dConcatClass
          "community-topic-aggregation__hero"
          (if @model.game.cover_url "--has-cover")
        }}
      >
        {{#if @model.game.cover_url}}
          <img
            class="community-topic-aggregation__cover"
            src={{@model.game.cover_url}}
            alt=""
          />
        {{/if}}
        <div class="community-topic-aggregation__identity">
          {{#if @model.game.icon_url}}
            <img
              class="community-topic-aggregation__icon"
              src={{@model.game.icon_url}}
              alt=""
            />
          {{/if}}
          {{#if @model.game.wordmark_url}}
            <img
              class="community-topic-aggregation__wordmark"
              src={{@model.game.wordmark_url}}
              alt={{@model.title}}
            />
          {{else}}
            <h1 class="community-topic-aggregation__title">{{@model.title}}</h1>
          {{/if}}
        </div>
      </header>
    {{else}}
      <h1 class="community-topic-aggregation__title">{{@model.title}}</h1>
    {{/if}}
    {{#if @model.topicList.topics.length}}
      <DLoadMore
        @selector=".community-topic-aggregation .topic-list tr"
        @action={{@model.topicList.loadMore}}
        class="paginated-topics-list"
      >
        <BasicTopicList
          @topicList={{@model.topicList}}
          @showPosters={{true}}
          @listContext="community-navigation"
          @listTitle={{@model.title}}
          @order={{@model.order}}
        />
        <DConditionalLoadingSpinner
          @condition={{@model.topicList.loadingMore}}
        />
      </DLoadMore>
    {{else}}
      <DEmptyState
        @title={{i18n "community_navigation.empty_topics_title"}}
        @body={{i18n "community_navigation.empty_topics_body"}}
      />
    {{/if}}
  </section>
</template>
